export default __webpack_public_path__ + "static/media/flower.0ead70c8.png";